import { useSnackbarStore } from '@/modules/global/stores/SnackbarStore'
import i18n from '@/util/config/i18n'
import type { SlashCommandBlockReason } from './tiptap-commands'

const DEDUPE_PREFIX = 'slash-command-blocked'

function messageKey(reason: SlashCommandBlockReason): string {
  switch (reason) {
    case 'scope':
    case 'handler':
      return 'slashCommands.blockedNesting'
    case 'stale':
      return 'slashCommands.blockedStale'
    case 'feature':
      return 'slashCommands.blockedFeature'
    case 'disabled':
      return 'slashCommands.blockedDisabled'
    default:
      return 'slashCommands.blockedNesting'
  }
}

export function enqueueSlashCommandBlockedSnackbar(reason: SlashCommandBlockReason): void {
  useSnackbarStore().enqueue({
    label: i18n.t(messageKey(reason)) as string,
    variant: 'warning',
    dedupeKey: `${DEDUPE_PREFIX}-${reason}`
  })
}
